module.exports = __webpack_public_path__ + "assets/027d982d7d3a4a5b015fc46ce2c9ec50.mp3";


/*****************
 ** WEBPACK FOOTER
 ** ./public-src/sounds/randWilds/WolfRunL.mp3
 ** module id = 386
 ** module chunks = 0
 **/